/**
 * Converts a Blob to a File object with a filename
 */
export const convertBlobToFile = (blob: Blob, filename: string): File => {
  return new File([blob], filename, {
    type: blob.type || "image/jpeg",
    lastModified: Date.now(),
  });
};

/**
 * Converts a base64 data URL to a File object
 */
export const base64toFile = (base64DataUrl: string, filename: string = "image.png"): File => {
  const base64Data = base64DataUrl.split(",")[1];
  const mimeType = base64DataUrl.split(";")[0].split(":")[1];
  const byteCharacters = atob(base64Data);
  const byteArray = Uint8Array.from(byteCharacters, c => c.charCodeAt(0));
  const blob = new Blob([byteArray], { type: mimeType });
  return new File([blob], filename, { type: mimeType });
};

/**
 * Converts a Blob to a base64 data URL
 */
export const blobToDataUrl = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

/**
 * Fetches an image from a URL and converts it to a base64 data URL
 * Useful for converting remote URLs to data URLs that can be sent to APIs
 */
export const urlToDataUrl = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const blob = await response.blob();
  return blobToDataUrl(blob);
};

